<div #container class="ocl-container-with-padding" [style.max-height]="maxHeight" fxLayout="column">
  <div #controls style="margin-bottom: 16px">
    <div fxLayout="row" fxLayoutAlign="space-between">
      <app-loading-header>Responsible Parties</app-loading-header>
      <div fxLayout="row" fxLayoutAlign="end end">
        <dx-drop-down-button
          style="height: 26px"
          [visible]="isPhone"
          [splitButton]="false"
          [showArrowIcon]="false"
          [dropDownOptions]="{ width: 100 }"
          icon="overflow"
          [items]="responsiveButtons"
          displayExpr="name"
          keyExpr="id"
          (onItemClick)="onItemClick($event)">
        </dx-drop-down-button>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="end" *ngIf="!isPhone">
      <div class="button-group">
        <dx-tooltip target="#addBtn" showEvent="dxhoverstart" hideEvent="dxhoverend">
          <div *dxTemplate="let data of 'content'">
            <p>Add</p>
          </div>
        </dx-tooltip>
        <dx-tooltip target="#removeBtn" showEvent="dxhoverstart" hideEvent="dxhoverend">
          <div *dxTemplate="let data of 'content'">
            <p>Remove</p>
          </div>
        </dx-tooltip>
        <dx-tooltip target="#upBtn" showEvent="dxhoverstart" hideEvent="dxhoverend">
          <div *dxTemplate="let data of 'content'">
            <p>Move Up</p>
          </div>
        </dx-tooltip>
        <dx-tooltip target="#downBtn" showEvent="dxhoverstart" hideEvent="dxhoverend">
          <div *dxTemplate="let data of 'content'">
            <p>Move Down</p>
          </div>
        </dx-tooltip>

        <dx-button
          id="upBtn"
          [icon]="'arrowup'"
          [disabled]="disableUp"
          title="Up"
          (click)="changeUp()"
          style="margin-right: 4px;margin-left: 4px;"
        ></dx-button>
        <dx-button
          id="downBtn"
          [icon]="'arrowdown'"
          [disabled]="disableDown"
          title="Down"
          (click)="changeDown()"
          style="margin-right: 4px;margin-left: 4px;"
        ></dx-button>
        <dx-button
          id="addBtn"
          [icon]="'add'"
          title="Add"
          (click)="showForm()"
          style="margin-right: 4px;margin-left: 4px;"
        ></dx-button>
        <dx-button
          id="removeBtn"
          [icon]="'trash'"
          title="Remove"
          [disabled]="selectedRowKeys.length === 0"
          (click)="removeClicked()"
          style="margin-right: 4px;"
        ></dx-button>
      </div>
    </div>
  </div>
  <dx-data-grid
    #grid
    [dataSource]="responsibleParties"
    (selectedRowKeysChange)="selectionChange()"
    (onContentReady)="refresh()"
    [(selectedRowKeys)]="selectedRowKeys"
    [showBorders]="true"
    [showRowLines]="true"
    [showColumnLines]="true"
    [hoverStateEnabled]="true"
    [highlightChanges]="true"
    [allowColumnResizing]="true"
    [height]="gridHeight"
    [columnHidingEnabled]="isPhoneOrTablet">
    <dxo-scrolling [showScrollbar]="'always'" [mode]="'virtual'"></dxo-scrolling>
    <dxo-filter-row [showOperationChooser]="true" [visible]="true"></dxo-filter-row>
    <dxo-filter-panel [visible]="true"></dxo-filter-panel>
    <dxo-selection mode="multiple" showCheckBoxesMode="always"></dxo-selection>

    <dxi-column dataField="lastName" [hidingPriority]="isPhoneOrTablet ? 2 : null"></dxi-column>
    <dxi-column dataField="firstName" [hidingPriority]="isPhoneOrTablet ? 1 : null"></dxi-column>
    <dxi-column dataField="phone" [hidingPriority]="isPhoneOrTablet ? 0 : null"></dxi-column>
  </dx-data-grid>
</div>

<app-patient-responsible-party-form-dialog (closed)="formClosed($event)"
                                           [popupVisible]="isEditorVisible"></app-patient-responsible-party-form-dialog>
